import { createAsyncThunk } from '@reduxjs/toolkit';
import { CompanyAdvertiseBulkStatus } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';

export interface CompanyAdvertiseBulkStatusParams {
  advertiseIds: string[];
  status: string;
}

export const companyAdvertiseBulkStatus = createAsyncThunk(
  'companyAdvertiseBulkStatus/companyAdvertiseBulkStatus',
  async (values: CompanyAdvertiseBulkStatusParams, { rejectWithValue }) => {
    try {
      const response = await CompanyAdvertiseBulkStatus.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

